import { SurveyQuestionRadiogroup } from 'survey-react-ui';

import { IonList, IonRadioGroup } from '@ionic/react';

import formControlStyles from '../../Form/FormControl/FormControl.module.scss';

export class SurveyRadioGroup extends SurveyQuestionRadiogroup {
  protected renderElement(): JSX.Element {
    var cssClasses = this.question.cssClasses;

    return (
      <IonList className={formControlStyles.list}>
        <IonRadioGroup
          value={this.question.value}
          name={this.question.name}
          ref={(el) => this.setControl(el)}
          onIonChange={({ detail: { value } }) =>
            this.question.setPropertyValue(this.question.questionName, value)
          }
        >
          {this.getBody(cssClasses)}
        </IonRadioGroup>
      </IonList>
    );
  }
}
